import React from 'react';
import { useDispatch } from 'react-redux';
import type { ButtonProps } from '../../components/Button';
import Button from '../../components/Button';
import UIActions from '../../ui/UIActions';

interface RefetchMentionButtonProps {
  refetch: () => void;
  variant?: 'link' | 'secondary';
  size?: ButtonProps['size'];
}

const RefetchMentionButton = ({
  refetch,
  variant = 'link',
  size,
}: RefetchMentionButtonProps) => {
  const dispatch = useDispatch();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => {
        refetch();
        dispatch(UIActions.clearToasts());
      }}
    >
      <strong>Try again</strong>
    </Button>
  );
};

export default RefetchMentionButton;
